"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWhiteListedHeaders = exports.writeLog = void 0;
const models_1 = require("../models");
const writeLog = (log) => {
    const level = log.level === 'error' ? 'stderr' : 'stdout';
    process[level].write(JSON.stringify(log) + '\n');
};
exports.writeLog = writeLog;
function getHeaderValue(key, headers) {
    var _a, _b;
    return (_b = (_a = headers === null || headers === void 0 ? void 0 : headers[key]) !== null && _a !== void 0 ? _a : headers === null || headers === void 0 ? void 0 : headers[key.toLowerCase()]) !== null && _b !== void 0 ? _b : headers === null || headers === void 0 ? void 0 : headers[key.toUpperCase()];
}
const mask = (text, offset) => {
    if (typeof text === 'number' && !isNaN(text)) {
        text = `${text}`;
    }
    if (!text || typeof text !== 'string') {
        return undefined;
    }
    return text.replace(text.slice(offset), '').padEnd(text.length, '*');
};
const mapWhiteListedHeaders = (headers) => {
    const unmaskedFields = models_1.headersUnmasked.reduce((acc, val) => {
        acc[val.key] = getHeaderValue(val.value, headers);
        return acc;
    }, []);
    const maskedFields = models_1.headersMasked.reduce((acc, val) => {
        acc[val.key] = mask(getHeaderValue(val.value, headers), val.maskLength);
        return acc;
    }, []);
    return {
        ...maskedFields,
        ...unmaskedFields,
    };
};
exports.mapWhiteListedHeaders = mapWhiteListedHeaders;
